import { getRoute } from '@utils/route';

export const SIGN_IN_USERNAME_PAGE_URL = '/sign-in/username';

export const routeSignInUsernamePage = () => getRoute(SIGN_IN_USERNAME_PAGE_URL);
